import { render, staticRenderFns } from "./BulkPointsAdjustmentForm.vue?vue&type=template&id=0d4720a8&scoped=true"
import script from "./BulkPointsAdjustmentForm.vue?vue&type=script&lang=js"
export * from "./BulkPointsAdjustmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4720a8",
  null
  
)

export default component.exports